<template>
  <div
    class="overflow-auto shadow-sm border rounded"
    :style="{ maxHeight: maxHeight }"
  >
    <table class="table table-sm table-striped table-hover mb-0">
      <thead class="thead-sticky-top">
        <tr>
          <!-- Columnas específicas de la vista (Producto o Tienda) -->
          <slot name="columns-start"></slot>

          <!-- ============ BLOQUE 1: ESTADO ============ -->
          <th scope="col" class="text-center align-middle " title="Activo">
            <div class="mb-1">
              <i class="fas fa-power-off fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Activo</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('activo')"
                @change="toggleColumnSelectAll('activo', $event)"
                class="custom-control-input"
                id="select-all-activo"
              />
              <label class="custom-control-label" for="select-all-activo">
                <span class="sr-only">Seleccionar todos: Activo</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle  border-right" title="Solicitud automática">
            <div class="mb-1">
              <i class="fas fa-magic fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Auto</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('sol_auto')"
                @change="toggleColumnSelectAll('sol_auto', $event)"
                class="custom-control-input"
                id="select-all-sol-auto"
              />
              <label class="custom-control-label" for="select-all-sol-auto">
                <span class="sr-only">Seleccionar todos: Solicitud automática</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle" title="Permitir ajustes">
            <div class="mb-1">
              <i class="fas fa-sliders-h fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Ajuste</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_ajustes')"
                @change="toggleColumnSelectAll('permitir_ajustes', $event)"
                class="custom-control-input"
                id="select-all-ajustes"
              />
              <label class="custom-control-label" for="select-all-ajustes">
                <span class="sr-only">Seleccionar todos: Permitir ajustes</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle " title="Permitir compras">
            <div class="mb-1">
              <i class="fas fa-shopping-cart fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Compra</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_compras')"
                @change="toggleColumnSelectAll('permitir_compras', $event)"
                class="custom-control-input"
                id="select-all-compras"
              />
              <label class="custom-control-label" for="select-all-compras">
                <span class="sr-only">Seleccionar todos: Permitir compras</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle " title="Permitir ventas">
            <div class="mb-1">
              <i class="fas fa-cash-register fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Venta</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_ventas')"
                @change="toggleColumnSelectAll('permitir_ventas', $event)"
                class="custom-control-input"
                id="select-all-ventas"
              />
              <label class="custom-control-label" for="select-all-ventas">
                <span class="sr-only">Seleccionar todos: Permitir ventas</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle " title="Permitir ingresos">
            <div class="mb-1">
              <i class="fas fa-arrow-down fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Ingr.</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_ingresos_t')"
                @change="toggleColumnSelectAll('permitir_ingresos_t', $event)"
                class="custom-control-input"
                id="select-all-ingresos"
              />
              <label class="custom-control-label" for="select-all-ingresos">
                <span class="sr-only">Seleccionar todos: Permitir ingresos</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle " title="Permitir salidas">
            <div class="mb-1">
              <i class="fas fa-arrow-up fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Sal.</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_salidas_t')"
                @change="toggleColumnSelectAll('permitir_salidas_t', $event)"
                class="custom-control-input"
                id="select-all-salidas"
              />
              <label class="custom-control-label" for="select-all-salidas">
                <span class="sr-only">Seleccionar todos: Permitir salidas</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle  border-right" title="Permitir devoluciones">
            <div class="mb-1">
              <i class="fas fa-undo-alt fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Dev.</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_devoluciones')"
                @change="toggleColumnSelectAll('permitir_devoluciones', $event)"
                class="custom-control-input"
                id="select-all-devoluciones"
              />
              <label class="custom-control-label" for="select-all-devoluciones">
                <span class="sr-only">Seleccionar todos: Permitir devoluciones</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle " title="Compra local">
            <div class="mb-1">
              <i class="fas fa-map-marker-alt fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">C.Loc.</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('compra_local')"
                @change="toggleColumnSelectAll('compra_local', $event)"
                class="custom-control-input"
                id="select-all-compra-local"
              />
              <label class="custom-control-label" for="select-all-compra-local">
                <span class="sr-only">Seleccionar todos: Compra local</span>
              </label>
            </div>
          </th>
          <th scope="col" class="text-center align-middle  border-right" title="Requerimiento manual">
            <div class="mb-1">
              <i class="fas fa-hand-paper fa-lg" aria-hidden="true"></i>
            </div>
            <div class="font-weight-bold mb-2 text-nowrap">Req.M.</div>
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                :checked="isColumnAllSelected('permitir_requerimiento_manual')"
                @change="toggleColumnSelectAll('permitir_requerimiento_manual', $event)"
                class="custom-control-input"
                id="select-all-req-manual"
              />
              <label class="custom-control-label" for="select-all-req-manual">
                <span class="sr-only">Seleccionar todos: Requerimiento manual</span>
              </label>
            </div>
          </th>

          <!-- Columnas opcionales intermedias (ej. abc) -->
          <slot name="columns-middle"></slot>

          <!-- ============ BLOQUE 4: CANTIDADES ============ -->
          <th scope="col" class="text-center align-middle  text-nowrap" title="Mínimo">Mín.</th>
          <th scope="col" class="text-center align-middle  text-nowrap" title="Máximo">Máx.</th>
          <th scope="col" class="text-center align-middle  text-nowrap" title="Stock">Stock</th>
          <th scope="col" class="text-center align-middle  text-nowrap" title="Unidad de medida de traslado">U.M.</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in configuraciones_producto_tienda"
          :key="item.id"
          :class="{ 'fila-deshabilitada': item.deshabilitado, 'text-muted': item.deshabilitado }"
        >
          <!-- Celdas iniciales -->
          <slot name="cells-start" :item="item"></slot>

          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'activo') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.activo"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`activo-${item.id}`"
              />
              <label class="custom-control-label" :for="`activo-${item.id}`">
                <span class="sr-only">Activo</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle border-right" :class="{ 'celda-editada': isFieldEdited(item, 'sol_auto') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.sol_auto"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`sol-auto-${item.id}`"
              />
              <label class="custom-control-label" :for="`sol-auto-${item.id}`">
                <span class="sr-only">Solicitud automática</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_ajustes') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_ajustes"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`ajustes-${item.id}`"
              />
              <label class="custom-control-label" :for="`ajustes-${item.id}`">
                <span class="sr-only">Permitir ajustes</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_compras') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_compras"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`compras-${item.id}`"
              />
              <label class="custom-control-label" :for="`compras-${item.id}`">
                <span class="sr-only">Permitir compras</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_ventas') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_ventas"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`ventas-${item.id}`"
              />
              <label class="custom-control-label" :for="`ventas-${item.id}`">
                <span class="sr-only">Permitir ventas</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_ingresos_t') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_ingresos_t"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`ingresos-${item.id}`"
              />
              <label class="custom-control-label" :for="`ingresos-${item.id}`">
                <span class="sr-only">Permitir ingresos</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_salidas_t') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_salidas_t"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`salidas-${item.id}`"
              />
              <label class="custom-control-label" :for="`salidas-${item.id}`">
                <span class="sr-only">Permitir salidas</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle border-right" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_devoluciones') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_devoluciones"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`devoluciones-${item.id}`"
              />
              <label class="custom-control-label" :for="`devoluciones-${item.id}`">
                <span class="sr-only">Permitir devoluciones</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle" :class="{ 'celda-editada': isFieldEdited(item, 'compra_local') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.compra_local"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`compra-local-${item.id}`"
              />
              <label class="custom-control-label" :for="`compra-local-${item.id}`">
                <span class="sr-only">Compra local</span>
              </label>
            </div>
          </td>
          <td class="text-center align-middle border-right" :class="{ 'celda-editada': isFieldEdited(item, 'permitir_requerimiento_manual') }">
            <div class="custom-control custom-switch d-inline-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                v-model="item.permitir_requerimiento_manual"
                :disabled="item.deshabilitado"
                class="custom-control-input"
                :id="`req-manual-${item.id}`"
              />
              <label class="custom-control-label" :for="`req-manual-${item.id}`">
                <span class="sr-only">Requerimiento manual</span>
              </label>
            </div>
          </td>

          <!-- Celdas intermedias -->
          <slot name="cells-middle" :item="item"></slot>

          <td class="text-center align-middle px-1" :class="{ 'celda-editada': isFieldEdited(item, 'minimo') }">
            <input
              type="number"
              v-model.number="item.minimo"
              min="0"
              max="1000000"
              style="width: 6.5rem"
              class="form-control form-control-sm mx-auto text-right font-weight-bold text-dark"
              :disabled="item.deshabilitado"
              :aria-label="'Mínimo fila ' + (item.codigo_tienda || item.id)"
            />
          </td>
          <td class="text-center align-middle px-1" :class="{ 'celda-editada': isFieldEdited(item, 'maximo') }">
            <input
              type="number"
              v-model.number="item.maximo"
              min="0"
              max="1000000"
              style="width: 6.5rem"
              class="form-control form-control-sm mx-auto text-right text-dark font-weight-bold"
              
              :aria-label="'Máximo fila ' + (item.codigo_tienda || item.id)"
            />
          </td>
          <!-- Stock (click para actualizar) -->
          <td class="text-center align-middle font-weight-bold">
            <a v-if="!item.deshabilitado"
               href="#"
               @click.prevent="actualizarExistencia(item)"
               :class="{
                 'text-danger': item.existencia <= item.minimo,
                 'text-warning': item.existencia > item.maximo,
                 'text-success': item.existencia > item.minimo && item.existencia <= item.maximo,
               }">
              {{ item.existencia }}
            </a>
            <span v-else class="text-muted">&mdash;</span>
          </td>

          <!-- U.M. Traslado Directamente Editable -->
          <td class="text-center align-middle px-1" :class="{ 'celda-editada': isFieldEdited(item, 'unidad_medida_solicitud') }">
            <select
              v-model="item.unidad_medida_solicitud"
              style="min-width: 6rem"
              class="custom-select custom-select-sm text-dark"
              :disabled="item.deshabilitado || !hasAllowedUnits(item)"
              :aria-label="'U.M. traslado fila ' + (item.codigo_tienda || item.id)"
            >
              <option value="" class="text-dark">— Sin U.M. —</option>
              <option
                v-for="unit in obtenerOpcionesUnidad(item)"
                :key="unit.unidad_medida"
                :value="unit.unidad_medida"
                class="text-dark"
              >
                {{ (unit.unidad_medida_obj && unit.unidad_medida_obj.nombre) || '' }}
              </option>
            </select>
          </td>
        </tr>

        <tr v-if="configuraciones_producto_tienda.length === 0">
          <td colspan="100" class="text-center text-muted py-5">
            <slot name="empty-state">
              <i class="fas fa-box-open fa-2x mb-2 d-block"></i>
              No hay datos disponibles.
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { clonarProfundo } from '@/utils'
import DynamicService from '@/services/commons/DynamicService'

export const CAMPOS_TRACKED = [
  'activo', 
  'sol_auto',
  'permitir_ajustes', 
  'permitir_compras', 
  'permitir_ventas',
  'permitir_ingresos_t', 
  'permitir_salidas_t', 
  'permitir_devoluciones',
  'compra_local', 
  'permitir_requerimiento_manual',
  'minimo', 
  'maximo', 
  'unidad_medida_solicitud',
]

export default {
  name: 'ProductoTiendaConfigTable',
  props: {
    configuraciones_producto_tienda: {
      type: Array,
      required: true,
    },
    // En ByProductComponent es un array simple. En ByTiendaComponent depende del SKU.
    allowedUnitsFn: {
      type: Function,
      default: null,
    },
    allowedUnits: {
      type: Array,
      default: () => ([]),
    },
    maxHeight: {
      type: String,
      default: '65vh',
    },
  },
  computed: {
    editedCount() {
      return this.configuraciones_producto_tienda.filter(item => this.isEdited(item)).length
    }
  },
  watch: {
    editedCount(newVal) {
      this.$emit('edited-count-change', newVal)
    }
  },
  methods: {
     handleScroll(event) {
      // Si el scroll baja más de 5 píxeles, activa el efecto
      this.isScrolled = event.target.scrollTop > 5;
    },

    getAllowedUnits(item) {
      if (this.allowedUnitsFn) return this.allowedUnitsFn(item)
      return this.allowedUnits
    },

    obtenerOpcionesUnidad(item) {
      const permitidas = this.getAllowedUnits(item)
      const guardado = item.unidad_medida_solicitud
      if (!guardado) return permitidas
      if (permitidas.some(u => u.unidad_medida === guardado)) return permitidas
      const objGuardado = item.unidad_medida_solicitud_obj || null
      return [{ unidad_medida: guardado, unidad_medida_obj: objGuardado }, ...permitidas]
    },

    hasAllowedUnits(item) {
      return this.obtenerOpcionesUnidad(item).length > 0
    },

    // ── EDIT TRACKER ──────────────────────────────────────────
    isEdited(item) {
      if (!item.originalValue || item.deshabilitado) return false
      return Object.keys(item.originalValue).some(
        key => item[key] !== item.originalValue[key]
      )
    },

    isFieldEdited(item, field) {
      if (!item.originalValue || item.deshabilitado) return false
      return item[field] !== item.originalValue[field]
    },

    getChangedFields(item) {
      if (!item.originalValue) return {}
      return Object.keys(item.originalValue).reduce((acc, key) => {
        if (item[key] !== item.originalValue[key]) acc[key] = item[key]
        return acc
      }, {})
    },

    buildUpdatePayload(item) {
      return {
        id: item.id,
        campos_modificados: this.getChangedFields(item),
      }
    },

    resetOriginal(item) {
      item.originalValue = clonarProfundo(
        CAMPOS_TRACKED.reduce((acc, key) => {
          acc[key] = item[key]
          return acc
        }, {})
      )
      this.$delete(item, 'errorInactivacion')
    },

    marcarErroresInactivacion(erroresPorRegistro) {
      this.configuraciones_producto_tienda.forEach(item => {
        const clave = this._claveRegistro(item)
        if (erroresPorRegistro[clave]) {
          this.$set(item, 'errorInactivacion', erroresPorRegistro[clave])
        } else {
          this.$delete(item, 'errorInactivacion')
        }
      })
    },

    getModifiedPayloads() {
      return this.configuraciones_producto_tienda
        .filter(item => this.isEdited(item))
        .map(item => this.buildUpdatePayload(item))
    },

    resetSavedItems() {
      this.configuraciones_producto_tienda.filter(item => this.isEdited(item)).forEach(item => {
        this.resetOriginal(item)
      })
    },

    resetSavedItemsExcluyendo(clavesExcluidas) {
      this.configuraciones_producto_tienda.forEach(item => {
        if (!this.isEdited(item)) return
        if (clavesExcluidas.includes(this._claveRegistro(item))) return
        this.resetOriginal(item)
      })
    },

    _claveRegistro(item) {
      return `${item.producto}-${item.tienda}`
    },

    descartarTodosLosCambios() {
      this.configuraciones_producto_tienda.forEach((item) => {
        if (this.isEdited(item)) {
          CAMPOS_TRACKED.forEach(k => {
            item[k] = item.originalValue[k]
          })
        }
      })
    },

    // ── ENCABEZADOS DE COLUMNA ────────────────────────────────
    isColumnAllSelected(key) {
      const targets = this.configuraciones_producto_tienda.filter(
        item => !item.deshabilitado && (key === 'activo' || item.activo)
      )
      if (targets.length === 0) return false
      return targets.every(item => item[key])
    },

    toggleColumnSelectAll(key, event) {
      const checked = event.target.checked
      this.configuraciones_producto_tienda.forEach((item) => {
        if (!item.deshabilitado && (key === 'activo' || item.activo)) {
          item[key] = checked
        }
      })
    },

    actualizarExistencia(item) {
      if (!item.producto) return
      DynamicService.getAction(
        'cat',
        'productos',
        item.producto,
        'actualizar_existencia_x_tienda',
        { tienda_id: item.tienda }
      )
        .then(() => {
          this.$emit('refresh-existencia')
        })
        .catch(() => {
          this.$emit('error-existencia', 'No se pudo actualizar la existencia')
      })
    },
  }
}
</script>


